import { useState } from "react"
import { Option, Sorting } from "../../search-spring/types/types"
import MobileSortFilterItem from "./MobileSortFilterItem"

type Props = {
  sorting: Sorting
}

const MobileSortingFilter = ({sorting}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [activeSort, setActiveSort] = useState('')

  const toggleAccordion = (): void => {
    setIsOpen(!isOpen)
  }

    return (
      <div className="flex flex-col px-5 py-2.5">
      <div className="flex justify-between" onClick={toggleAccordion}>
        <h2 className="font-bstSpyre uppercase text-sm">Sort By</h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none"
          className={`transform transition-transform ${isOpen ? 'rotate-90' : ''}`}
        >
          <path d="M2.91675 1.4165L6.92717 5.99984L2.91675 10.5832" stroke="black" strokeLinecap="round"/>
        </svg>
      </div>
      <div className={`transition-max-height duration-200 ${isOpen ? 'max-h-screen mt-MD ' : 'overflow-hidden max-h-0'}`}>
        <div className="flex flex-col">
          {sorting.options.map((sortingOrder: Option, subIndex: number) => (
           <MobileSortFilterItem key={subIndex} sortingOrder={sortingOrder} subIndex={subIndex} activeSort={activeSort} setActiveSort={setActiveSort} />
          ))}
        </div>
      </div>
    </div>
    )
}

export default MobileSortingFilter